<template >
<div>
  <MenuProductos :value="0"></MenuProductos>

  <v-data-table
    :headers="headers"
    :items="getAllProductos"
    :search="search"
    class="elevation-1"
    v-if="!cargamasiva"
  >
    <template v-slot:top >
 
        <v-row class="pa-3" dense>
          <v-col cols="12" md="2">
            <span class="font-weight-bold">PRODUCTOS Y SERVICIOS</span> 
          </v-col>
          <v-col cols="12" md="8">
            <!-- <v-divider class="mx-4" inset  vertical ></v-divider> -->
            <v-text-field
                  v-model="search"
                  type="text"
                  append-icon="mdi-magnify"
                  label="Buscar por producto..."
                  dense
                  outlined
                  hide-details
              ></v-text-field> 
            
          </v-col>
          <v-col cols="6" md="1" class="text-center" style="display: flex;">
            <v-btn color="green" dark  @click="descargarExcel" class="mr-3" title="Descargar productos"><v-icon>mdi-microsoft-excel</v-icon></v-btn>
            <v-btn color="#EF6C00" dark  @click="cargamasiva=true" class="mr-3" title="Carga masiva de productos"><v-icon>mdi mdi-database-import</v-icon></v-btn>
            <v-btn  color="primary"  dark  to="/productos/creareditar" title="Crear nuevo producto" class="mr-3">
              <v-icon>mdi-plus-thick</v-icon>              
            </v-btn>
          </v-col>
        </v-row>
        
        
    </template>
    <template v-slot:[`item.tipo`]="{ item }">
      <p v-text="item.tipo"></p>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small  class="mr-2"  @click="editItem(item)" >
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item.idarticulo)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Recargar</v-btn>
    </template>
  </v-data-table>

  <DataTableProd v-if="cargamasiva" @cerrartable="cargamasiva=false"></DataTableProd>
  <!-- Dialog crear y editar existencias -->
  <v-dialog v-model="dialog" max-width="800">     
      <FormCrear @setdata="setProducto" ref="formCrear" :dataitem="producto">

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary"  @click="crearProducto()">
              Guardar Cambios
            </v-btn>

            <v-btn text @click="dialog = false">
              Cancelar
            </v-btn>

        </v-card-actions>
      
      </FormCrear>

       
    </v-dialog>
  </div>
</template>

<script>
import {json2excel} from 'js2excel';
import axios from 'axios'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
import MenuProductos from './menu/menu'
import DataTableProd from './components/DataTableProd.vue';
import FormCrear from './CrearEditar.vue'

export default {
     name:'Productos', 
     components:{
      MenuProductos,FormCrear,DataTableProd
     }, 
     data: () => ({
      dialog:false,
      cargamasiva:false,
      search:'',
      producto:'',
      idestablecimiento:1,
      headers:[
        { text: 'Cod.', align: ' d-none d-sm-table-cell' , value: 'codigo' },
        { text: 'Nombre', value: 'nombre',width: '50%'},
        { text: 'Precio Compra',align: 'center', value: 'preciocompra' },
        { text: 'Precio Sugerido',align: 'center', value: 'preciosugerido' },
        { text: 'Precio Minimo',align: 'center', value: 'preciominimo'},
        { text: 'Actions',align: 'center', value: 'actions', sortable: false },
        ]
    }),

    computed: {
      ...mapGetters(['getAllProductos','getTokenUser','getEstablecimientosActivas'])
    },

    async created () {
      await this.initialize()
    },

    methods: {  
      async initialize () {  
        await this.$store.dispatch('setAllEstablecimientos')  
        await this.$store.dispatch('setProductos')      
      },
      editItem (item) {
        this.producto = item
        this.dialog = true    
        //this.$router.push({name: 'ProductoCrearEditar', params: { id: item.idarticulo}});
        
      },

      async crearProducto(){
           await this.$refs.formCrear.save()
           await this.initialize()
           this.dialog = false
      },

      setProducto(data){
        try {
          this.producto = data
          this.dialog = false
          this.alertDone();
        } catch (error) {
          this.alertError()
        }
            
      },

      deleteItem (idarticulo) {
        
        Swal.fire({
          title: 'Esta Seguro?',
          text: "El registro será Desactivado!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Desactivar!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {
            //Procedimiento para eliminarlo
            this.cambiarestado("Eliminado",idarticulo)
          }
        })
       
              
      },
      cambiarestado(estado,idarticulo) {
        axios.put(`${this.$store.state.urlapi}/articulos/${idarticulo}`,{estado:estado},this.getTokenUser)
          .then(() => {
            this.alertDone();
            this.initialize();
          });
      },
      print(){
        window.open("/reportes/inventarioprod.php","blank")
      },
      descargarExcel(){
        const elementos = []
        this.getAllProductos.map(function(item) {         
          item.preciocompra = parseFloat(item.preciocompra)
          item.preciosugerido = parseFloat(item.preciosugerido)
          item.preciominimo = parseFloat(item.preciominimo)
          elementos.push(item)
        })

        const data = elementos
        try {
            json2excel({
                data,
                name: 'Inventario_Productos',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      //Notificaciones Swal
      alertDone(){
        Swal.fire({
          icon: 'success',
          title: 'Realizado',
          showConfirmButton: false,
          timer: 1500
        })
      },
      alertError(){
        Swal.fire({
          icon: 'error',
          title: 'No pudo realizarse la solicitud',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    
}
</script>
<style lang="css">
.v-data-table td{
  font-size: 12px !important;
  height: 35px !important;
}

</style>
